// extracted by mini-css-extract-plugin
export default {"imageWrapper":"pL-z","twoColumnImage":"qL-z"};